import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AmenitiesService} from '../../../services/amenities.service';
import {ApiClientService} from '../../../services/api-client.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {UrlService} from '../../../services/url.service';
import {Subscription} from 'rxjs/Subscription';

declare const $: any;
declare const moment: any;
declare const toastr: any;

@Component({
    selector: 'amenities-calendar-view',
    templateUrl: './amenities-calendar-view.component.html',
    styleUrls: ['./amenities-calendar-view.component.scss']
})
export class AmenitiesCalendarViewComponent implements OnInit, AfterViewInit, OnDestroy {
    calendarOptions: any;
    private subscribeUrlChange: Subscription = new Subscription();

    constructor(public amenitiesService: AmenitiesService,
                public api: ApiClientService,
                private authenticationService: AuthenticationService,
                private urlService: UrlService
    ) {
    }

    ngOnInit() {
        this.calendarOptions = {
            editable: false,
            displayEventEnd: true,
            eventLimit: true,
            timeFormat: 'h:mma',
            displayEventTime: true,
            showNonCurrentDates: false,
            fixedWeekCount: false,
            header: {
                left: 'title prev,next',
                center: '',
                right: ''
            },
            events: this.amenitiesService.eventsForCalendar,
            eventRender: (event, $model: any) => {
                if ($model[0].childNodes[0].childNodes && $model[0].childNodes[0].childNodes.length > 2) {
                    const tempSaver = $model[0].childNodes[0].childNodes[0].outerHTML;
                    $model[0].childNodes[0].childNodes[0].outerHTML = $model[0].childNodes[0].childNodes[2].outerHTML;
                    $model[0].childNodes[0].childNodes[2].outerHTML = tempSaver;
                }
                $model[0].childNodes[0].innerHTML = `<div style="padding-top: 2px;"><i class="fa fa-user fa-2x" aria-hidden="true"></i></div><div class="event-info">${$model[0].childNodes[0].innerHTML}</div>`;
                let start;
                let end;
                const timezoneOffset = new Date().getTimezoneOffset() / 60;
                if (event.start)
                    start = moment(event.start._d).add(timezoneOffset, 'hours').format('MMM D');
                if (event.end)
                    end = moment(event.end._d).add(timezoneOffset, 'hours').format('MMM D');
                if ($model[0].childNodes[0].innerHTML.indexOf('fc-time') == -1) {
                    $model[0].childNodes[0].childNodes[1].innerHTML += `<span class="fc-time">${start} ${end ? ('- ' + end) : ''}</span>`;
                }
                if (event.end && event.start && Math.abs(new Date(event.end._i).getTime() - new Date(event.start._i).getTime()) > 86399000) {
                    $model[0].childNodes[0].childNodes[1].childNodes[2].innerHTML = `${start} - ${end}`;
                }

                if (!this.authenticationService.userIsResident && !event.disabledDate && event.booking && !event.hiddenBooking) {
                    let dropdownItems = '';
                    if (event.booking.isCanApprove && this.amenitiesService.allPaymentArePaid(event.booking) &&
                        (event.booking.status == 'pending' || event.booking.status == 'declined')) {
                        dropdownItems += this.getCalendarDropdownItemHTML('Approve');
                    }
                    if (event.booking.isCanApprove && (event.booking.status == 'approved' || event.booking.status == 'pending')) {
                        dropdownItems += this.getCalendarDropdownItemHTML('Decline');
                    }
                    if (event.booking.isCanEdit && (event.booking.status == 'pending' || event.booking.status == 'declined')) {
                        dropdownItems += this.getCalendarDropdownItemHTML('Edit');
                    }
                    if (event.booking.isCanDelete) {
                        dropdownItems += this.getCalendarDropdownItemHTML('Delete');
                    }
                    if (event.booking.isCanEdit && this.amenitiesService.bookingHasPayments(event.booking)) {
                        dropdownItems += this.getCalendarDropdownItemHTML('Pay');
                    }
                    if (dropdownItems) {
                        const div = document.createElement('div');
                        div.classList.add('dropdown-button-wrapper');
                        div.innerHTML = `
                            <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs" aria-expanded="false" style="background: transparent; border: none;">
                                <i class="fa fa-chevron-down"></i>
                            </button>
                        `;
                        div.innerHTML += '<ul class="dropdown-menu pull-right">' + dropdownItems + '</ul>';
                        $model[0].childNodes[0].appendChild(div);
                    }

                    const divStatus = document.createElement('div');
                    divStatus.classList.add('label-status');
                    const labelStatus = `label-${event.booking.status}`;
                    // if (event.booking.status == 'pending') labelStatus = 'label-pending';
                    // if (event.booking.status == 'approved') labelStatus = 'label-approved';
                    // if (event.booking.status == 'declined') labelStatus = 'label-declined';
                    // if (event.booking.status == 'expired') labelStatus = 'label-expired';
                    divStatus.classList.add(labelStatus);
                    $model[0].childNodes[0].appendChild(divStatus);
                    divStatus.innerHTML = `<div>
                                            <span>${event.booking.status}</span>
                                        </div>`;
                }
                if (event.disabledDate && event.note) {
                    const popoverButton = document.createElement('div');
                    popoverButton.style.position = 'absolute';
                    popoverButton.style.right = '0';
                    popoverButton.style.top = '5px';
                    popoverButton.innerHTML = `
                        <i class="fa fa-sticky-note-o" aria-hidden="true"></i>
                    `;
                    $model[0].childNodes[0].appendChild(popoverButton);
                    $(popoverButton).popover({
                        content: `<pre style="min-width: 200px; max-height: 400px;">${event.note}</pre>`,
                        placement: 'auto',
                        trigger: 'hover',
                        html: true
                    });
                }
            },
            dayRender: (date, cell: any) => {
                if (this.amenitiesService.account.canUpdate(this.amenitiesService.serviceName) &&
                    cell[0].classList.contains('fc-disabled-day') == -1 &&
                    new Date(moment(date).format('YYYY/MM/DD')) >= new Date(moment(new Date()).format('YYYY/MM/DD')))
                    cell[0].innerHTML = '<div class="plus-wrapper"><i class="fa fa-2x fa-plus-circle"></i></div>';
            },
            dayClick: (date, jsEvent, view) => {
                if (!this.amenitiesService.calendarSpinnerShow && jsEvent.target.classList.value == 'fa fa-2x fa-plus-circle') {
                    this.amenitiesService.isAmenityModalShow = true;
                    this.amenitiesService.prefilledDateFromCaledar = moment(date).format('DD.MM.YYYY');
                }
            },
            eventClick: (event, clickTarget) => {
                if (event.hiddenBooking)
                    return;

                try {
                    const target = $(clickTarget.target);
                    const currentEvent = target.closest('.fc-event');

                    target.closest('.fc-view-container').find('.increase-z-index').removeClass('increase-z-index');

                    currentEvent.find('.fc-content').addClass('increase-z-index');
                    currentEvent.find('.dropdown-toggle').parent().removeClass('dropup');
                    if (window.innerHeight - clickTarget.clientY < 105) {
                        currentEvent.find('.dropdown-toggle').parent().addClass('dropup');
                    }

                    const weekRow = target.closest('.fc-row');
                    if (weekRow.length) {
                        if (!weekRow.hasClass('increase-z-index')) {
                            weekRow.addClass('increase-z-index');
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
                if (!event.disabledDate) {
                    if (
                        !clickTarget.target.classList.contains('fa-chevron-down') &&
                        !clickTarget.target.classList.contains('dropdown-toggle') &&
                        !clickTarget.target.classList.contains('calendar-dropdown-item')
                    ) {
                        this.openViewAmenityModal(event);
                    } else if (!this.authenticationService.userIsResident) {
                        if (clickTarget.target.innerText == 'Approve')
                            this.amenitiesService.approveBooking(event.booking);
                        else if (clickTarget.target.innerText == 'Decline')
                            this.amenitiesService.declineBooking(event.booking);
                        else if (clickTarget.target.innerText == 'Edit')
                            this.amenitiesService.editAmenity(event.booking);
                        else if (clickTarget.target.innerText == 'Delete')
                            this.amenitiesService.deleteAmenity(event.booking.id);
                        else if (clickTarget.target.innerText == 'Pay')
                            this.amenitiesService.showPaymentModal(event.booking);
                    }
                } else {
                    this.amenitiesService.selectedDisabledDate = event;
                    this.amenitiesService.isDisabledDateModalShown = true;
                }
            },
            viewRender: () => this.getAmenities()
        };
        $(document).on('click', '.fc-button-group', () => {
            this.clickButton();
        });
        setTimeout(() => $('#ucCalendar').fullCalendar(this.calendarOptions), 500);
    }

    clickButton() {
        if (document.getElementsByClassName('fc-view-container').length < 2) {
            this.modifyCalendarDesign();
            this.getAmenities();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.subscribeUrlChange = this.urlService.onUrlChange.subscribe(() => {
                this.getAmenities();
                this.modifyCalendarDesign();
            });
        }, 500);
    }

    modifyCalendarDesign(): void {
        for (let i = 0; i < document.getElementsByClassName('fc-day-header').length; i++)
            (<any>document.getElementsByClassName('fc-day-header')[i]).innerText = (<any>document.getElementsByClassName('fc-day-header')[i]).innerText.toUpperCase();
    }

    openViewAmenityModal(booking): void {
        if (booking.currentUserBooking === 1 || !this.authenticationService.userIsResident) {
            this.amenitiesService.calendarSpinnerShow = true;
            const url = `/v1/booking/${booking.id}.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,event,event.bookings,event.bookings.suite,event.bookings.resident`;
            this.api.get('domainAmenities', url).subscribe((res) => {
                const parsedBooking = [];
                const booking = [JSON.parse(res._body)];
                booking.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.amenitiesService.account.addEntitiesPermissions(booking, this.amenitiesService.serviceName);
                this.amenitiesService.bookingsFactory(booking, parsedBooking);
                this.amenitiesService.amenityInAmenityModal = parsedBooking[0];
                this.amenitiesService.calendarSpinnerShow = false;
                this.amenitiesService.isAmenityViewShow = true;
            });

        }

    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.amenitiesService.getData();
    }

    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {
        if (!targetElement || !targetElement.className) {
            return;
        }

        if (!targetElement.className || !targetElement.className.indexOf ||
            (targetElement.className.indexOf('fa-chevron-down') == -1 &&
                targetElement.className.indexOf('dropdown-toggle') == -1 &&
                targetElement.className.indexOf('calendar-dropdown-item') == -1)) {
            const elements = document.getElementsByClassName('increase-z-index');
            if (elements && elements.length > 0) {
                for (let i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('increase-z-index');
                }
            }
        }
    }

    private getCalendarDropdownItemHTML(itemName: string) {
        return `<li class="calendar-dropdown-item">
                    ${itemName}
                </li>`;
    }

    ngOnDestroy(): void {
        this.subscribeUrlChange.unsubscribe();
    }

    private getAmenities() {
        if (this.authenticationService.userIsResident) {
            this.amenitiesService.getAmenitiesForCalendarResident();
        } else {
            this.amenitiesService.getAmenitiesForCalendar();
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-calendar-view/amenities-calendar-view.component.ts